import React from "react";

import { RecommendedProductI } from "../../App.types";
import { prepareProductItem } from "../../tracking/googleAnalytics";
import { triggerCustomEvent } from "../../utils/helpers/chromeEvents";
import { formatDiscountPrice } from "../../utils/helpers/prices";
import { useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";
import Button from "../ui/button/Button";

interface ProductPropsI {
	product: RecommendedProductI;
	index: number;
}

export const Product = (props: ProductPropsI) => {
	const { product, index } = props;
	const currencyCode = useSelector((state) => state.popup.currencyCode);

	const addToCart = () => {
		triggerCustomEvent("addToCart", {
			regionalProductSku: product.regionalProductSku,
			clickTrackingUrl: product.clickTrackingUrl,
			url: product.url,
			name: product.productName,
			price: product.priceValue,
			sellerId: product.sellerId,
			sellerName: product.sellerName,
			brand: product.manufacturer,
			navigationPath: product.navigationPath,
			currencyCode,
			groupId: product.groupId,
			subGroupId: product.subGroupId,
			divisionId: product.divisionId,
			groupName: product.groupName,
			subGroupName: product.subGroupName,
			divisionName: product.divisionName,
			renewalPeriod: product.renewalPeriod,
			listActionField: "AddToCartPopup",
			trackingData: prepareProductItem({
				...product,
				index,
				productId: product.regionalProductSku,
				item_list_name: "AddToCartPopup",
				item_list_id: "recommendation_list",
			}),
		});
	};

	const buyMessage = product.displayAsSubscriptionProduct
		? product.buyMessage
		: strings.buy;

	const boughtMessage = product.displayAsSubscriptionProduct
		? product.buyMessage
		: strings.bought;

	return (
		<li
			key={product.regionalProductSku}
			className="recommended-product"
			aria-label={product.productName}
			title={product.productName}
			data-testid={`carousel-product-${product.regionalProductSku}`}
		>
			<img
				src={product.imgUrl}
				alt={product.productName}
				width="100"
				height="140"
				loading="lazy"
				decoding="async"
			/>
			<div className="recommended-product-content">
				<div className="product-list-details">
					<a
						href={`${product.url}?productList=AddToCartPopup&position=${index + 1
							}`}
						target="_blank"
						className="product-name"
						rel="noreferrer"
					>
						{product.productName}
					</a>

					<p className="highlights">{product.productDescription}</p>

					<div className="prices">
						<span className="current">{product.price}</span>
						{product.previousPrice !== product.price && (
							<>
								<span className="before">
									{product.previousPrice}
								</span>
								<span className="discount">
									{strings["addtocartpopup.subscription.yousave"]
										.replace("{youSave}", formatDiscountPrice({ previousPrice: product.previousPrice, price: product.price }))
									}
								</span>
							</>
						)}
					</div>
				</div>
				<Button
					message={buyMessage}
					bought={boughtMessage}
					className="tertiary-purple recommended-product-button"
					onClick={addToCart}
				/>
			</div>
		</li >
	);
};
